enum dataHooks {
  errorApp = 'error-app',
  backgroundImage = 'background-image',
  errorLayout = 'error-layout',
  errorDescription = 'error-description',
  errorRequestId = 'error-request-id',
  errorButton = 'error-button',
  errorCode = 'error-code',
  root = 'root',
  symphonyHeader = 'symphony-header',
  symphonyMenuButton = 'symphony-menu-button',
}

export default dataHooks;
